__webpack_require__.p = "/guest-website-frontend@v1-8-28/_next/";